import { createFileRoute } from '@tanstack/react-router'
import { ProgramTrash } from './ProgramTrash'

export const Route = createFileRoute('/program_/trash/')({
  component: () => <ProgramTrash />,
})
